import React from 'react';
import GenericModal from "./GenericModal";

export default function ConfirmationModal(props){

    const {title,text,children,onConfirm} = props;

    const [isOpened,setIsOpened] = React.useState(false);

    function yes(){
        setIsOpened(false)
        onConfirm();
    }

    function open(){
        setIsOpened(true)
    }

    return (
        <div className={'d-inline-block'}>

            <div className={'d-inline-block'} onClick={open}>
                {children}
            </div>


            <GenericModal
                isOpen={isOpened}
                onNegative={()=>{console.log('on negative');setIsOpened(false)}}
                onPositive={yes}
                positiveText={props.positiveText || 'Oui'}
                negativeText={props.negativeText || 'Non'}
                maxWidth={'sm'}
                title={title}
            >

                <div>
                    {text}
                </div>

            </GenericModal>

        </div>
    );
}